import {
  GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING,
  GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE,
} from "redux/types";

const initialState = {
  getExternalProjectsLoading: false,
  externalProjectsCategoriesData: null,
  errors: null,
};

export const getExternalProjectsCategoriesReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING:
      return { ...state, getExternalProjectsLoading: action.payload };
    case GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS:
      return { ...state, externalProjectsCategoriesData: action.payload };
    case GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
